import React from 'react';
import { Box } from '@mui/system';
import DependsOnDropdown from '../../sidebar/components/dependsOnDropdown';
import DrawerGlobalComp from '../../../../../../components/Drawer';
import DeleteCard from '../../../Kanban/DeleteCard';
import ChangeBoard from '../changeBoard/ChangeBoard';

export const MobileDrawer = ({
  filterDrawer,
  setFilterDrawer,
  cardId,
  boardId,
  setShowDetails,
  card,
  checkIsOwnerOrAdmin,
  accessForEditCard,
  cardDetail,
  accessForDeleteCard,
}) => {
  return (
    <DrawerGlobalComp open={filterDrawer} setOpen={setFilterDrawer}>
      <Box p={1}>
        {accessForDeleteCard && (
          <DeleteCard
            cardId={cardId}
            boardId={boardId}
            setShowDetails={setShowDetails}
          />
        )}
        {card && checkIsOwnerOrAdmin && (
          <ChangeBoard
            cardId={cardId}
            card={card}
            accessForEditCard={checkIsOwnerOrAdmin}
          />
        )}

        {card &&
          cardDetail &&
          !cardDetail?.card_has_subtask &&
          accessForEditCard && (
            <DependsOnDropdown cardId={Number(cardId)} card={card} />
          )}
      </Box>
    </DrawerGlobalComp>
  );
};
